<app-tool-scanner *ngIf="shouldRenderScanStatus()"></app-tool-scanner>

<app-form-error-list *ngIf="showErrors" [errorMap]="formControl.errors"></app-form-error-list>
<app-tree [(selectedItems)]="selectedTools"
          [isMaterial]="isMaterial"
          [label]="labelText"
          [emptyMessage]="emptyMessage"
          [noToolsMessage]="noToolsMessage"
          [(items)]="items"
          [scanningEnabled]="scanEnabled"
          [selectDisabled]="inspectEnabled"
          [propagateSelectionUp]="propagateSelectionUp"
          [loading]="loading"
          [isScanListenerActive]="isScanListenerActive"
          (scan)="onScan($event)"
          (select)="onToolSelect($event)"
          (unselect)="onToolUnselect($event)"
          (selections)="onSelections($event)"
          (rowAlertClick)="onRowAlertClick($event)"
></app-tree>

